import { DealState } from '@/lib/graphql/generated/graphql';
import { atom } from 'jotai';

export const dealStateState = atom<DealState | null>(null);
